// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════
   기본 스타일 — 리셋 · 타이포 · 레이아웃 유틸
   ══════════════════════════════════════════════════════════════════ */
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  -webkit-text-size-adjust: 100%;
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--surface);
  color: var(--ink);
  font-family: var(--f-b);
  font-size: var(--t-body);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  word-break: keep-all;
  overflow-x: hidden;
}

h1, h2, h3, h4, h5, h6 {
  font-family: var(--f-d);
  color: var(--ink);
  margin: 0;
  letter-spacing: -0.02em;
  line-height: 1.15;
  text-wrap: balance;
}

p {
  margin: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

ul, ol {
  margin: 0;
  padding: 0;
  list-style: none;
}

img, svg, canvas {
  display: block;
  max-width: 100%;
}

button, input, select, textarea {
  font: inherit;
  color: inherit;
}

button {
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0;
}

:focus-visible {
  outline: 2px solid var(--brand);
  outline-offset: 2px;
  border-radius: 3px;
}

::selection {
  background: var(--brand-soft-2);
  color: var(--brand-ink);
}

/* ── 스킵 링크 ─────────────────────────────────────── */
.skip-link {
  position: absolute;
  left: 12px;
  top: -60px;
  z-index: 200;
  padding: 10px 14px;
  border-radius: var(--r-1);
  background: var(--ink);
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  transition: top 0.15s;
}

.skip-link:focus {
  top: 12px;
  outline: 2px solid var(--brand);
}

/* ── 레이아웃 ───────────────────────────────────────── */
.wrap {
  width: 100%;
  max-width: var(--wrap);
  margin: 0 auto;
  padding: 0 var(--gutter);
}

.wrap--narrow {
  max-width: var(--wrap-narrow);
}

.sec {
  padding: 88px 0;
}

.sec--tight {
  padding: 56px 0;
}

.sec--alt {
  background: var(--surface-2);
  border-top: 1px solid var(--line-2);
  border-bottom: 1px solid var(--line-2);
}

.app-main {
  min-height: calc(100vh - var(--header-h));
}

/* ── 섹션 헤더 ─────────────────────────────────────── */
.kicker {
  font-family: var(--f-m);
  font-size: var(--t-mono);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--ink-3);
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.kicker--brand {
  color: var(--brand);
}

.kicker--spark {
  color: var(--spark-text);
}

.kicker::before {
  content: "";
  width: 20px;
  height: 2px;
  background: currentColor;
  opacity: 0.8;
}

.kicker--plain::before {
  display: none;
}

.sec-head {
  margin-bottom: 40px;
  max-width: 62ch;
}

.sec-head--center {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.sec-head--center .kicker {
  justify-content: center;
}

.sec-title {
  font-size: var(--t-h2);
  font-weight: 800;
  margin-top: 12px;
  letter-spacing: -0.028em;
}

.sec-lede {
  margin-top: 12px;
  color: var(--ink-2);
  font-size: 15.5px;
  line-height: 1.65;
  max-width: 58ch;
}

.sec-head--center .sec-lede {
  margin-left: auto;
  margin-right: auto;
}

/* ── 페이지 헤더 (내부 페이지) ─────────────────────── */
.page-head {
  padding: 44px 0 28px;
  border-bottom: 1px solid var(--line-2);
  background:
    linear-gradient(180deg, var(--surface-2) 0%, var(--surface) 100%);
}

.page-head .crumb {
  font-family: var(--f-m);
  font-size: var(--t-mono);
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--ink-3);
  display: flex;
  gap: 8px;
  align-items: center;
}

.page-head .crumb a:hover {
  color: var(--brand);
}

.page-head .crumb .sep {
  opacity: 0.5;
}

.page-head h1 {
  font-size: clamp(28px, 3.4vw, 40px);
  font-weight: 800;
  margin-top: 10px;
  letter-spacing: -0.03em;
}

.page-head .lede {
  margin-top: 10px;
  color: var(--ink-2);
  max-width: 62ch;
  font-size: 15px;
}

.page-head--row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
}

.page-body {
  padding-top: 36px;
  padding-bottom: 80px;
}

@media (max-width: 640px) {
  .page-body {
    padding-top: 24px;
    padding-bottom: 56px;
  }
  .page-head {
    padding: 28px 0 22px;
  }
}

/* ── 텍스트 유틸 ───────────────────────────────────── */
.mono {
  font-family: var(--f-m);
  font-variant-numeric: tabular-nums;
}

.num {
  font-variant-numeric: tabular-nums;
}

.muted {
  color: var(--ink-3);
}

.muted-2 {
  color: var(--ink-2);
}

.brand {
  color: var(--brand);
}

.spark {
  color: var(--spark);
}

.sm {
  font-size: var(--t-sm);
}

.xs {
  font-size: var(--t-xs);
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ── 플렉스/그리드 유틸 ────────────────────────────── */
.row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.row--between {
  justify-content: space-between;
}

.row--wrap {
  flex-wrap: wrap;
}

.col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.grow {
  flex: 1 1;
  min-width: 0;
}

.stack > * + * {
  margin-top: 16px;
}

/* ── 아이소 격자 배경 ──────────────────────────────── */
.iso-grid-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.55;
  background-image:
    repeating-linear-gradient(26.565deg, transparent 0 33px, var(--iso-grid) 33px 34px),
    repeating-linear-gradient(-26.565deg, transparent 0 33px, var(--iso-grid) 33px 34px);
  mask-image: radial-gradient(ellipse 66% 62% at 50% 52%, #000 25%, transparent 76%);
}

.iso-grid-bg--flat {
  mask-image: linear-gradient(180deg, transparent, #000 20%, #000 80%, transparent);
}

/* ── 아이소 리프트 (Z축 상승 호버) ─────────────────── */
.iso-lift {
  transition: transform var(--dur) var(--ease), box-shadow var(--dur) var(--ease);
}

.iso-lift:hover {
  transform: translate(-4px, -4px);
  box-shadow: var(--sh-iso-hover);
}

/* ── 등장 애니메이션 ───────────────────────────────── */
@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.rise {
  animation: rise 0.55s var(--ease-out) both;
}

.rise-1 { animation-delay: 0.05s; }
.rise-2 { animation-delay: 0.12s; }
.rise-3 { animation-delay: 0.2s; }
.rise-4 { animation-delay: 0.28s; }
.rise-5 { animation-delay: 0.36s; }

@keyframes fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  *, *::before, *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
  }
}

/* ── 스크롤바 (웹킷) ────────────────────────────────── */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: var(--line-strong);
  border-radius: 10px;
  border: 2px solid var(--surface);
}

::-webkit-scrollbar-track {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA;;uEAEuE;AACvE;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,qDAAqD;AACrD;EACE,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,sCAAsC;EACtC;qEACmE;AACrE;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;wFAEsF;EAE9E,kFAAkF;AAC5F;;AAEA;EAEU,iFAAiF;AAC3F;;AAEA,8CAA8C;AAC9C;EACE,+EAA+E;AACjF;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,kDAAkD;AAClD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;AAClC,UAAU,qBAAqB,EAAE;AACjC,UAAU,sBAAsB,EAAE;AAClC,UAAU,sBAAsB,EAAE;;AAElC;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;EACzC;AACF;;AAEA,oDAAoD;AACpD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* ══════════════════════════════════════════════════════════════════\n   기본 스타일 — 리셋 · 타이포 · 레이아웃 유틸\n   ══════════════════════════════════════════════════════════════════ */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  background: var(--surface);\n  color: var(--ink);\n  font-family: var(--f-b);\n  font-size: var(--t-body);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  word-break: keep-all;\n  overflow-x: hidden;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--f-d);\n  color: var(--ink);\n  margin: 0;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  text-wrap: balance;\n}\n\np {\n  margin: 0;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nul, ol {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\nimg, svg, canvas {\n  display: block;\n  max-width: 100%;\n}\n\nbutton, input, select, textarea {\n  font: inherit;\n  color: inherit;\n}\n\nbutton {\n  cursor: pointer;\n  background: none;\n  border: 0;\n  padding: 0;\n}\n\n:focus-visible {\n  outline: 2px solid var(--brand);\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n::selection {\n  background: var(--brand-soft-2);\n  color: var(--brand-ink);\n}\n\n/* ── 스킵 링크 ─────────────────────────────────────── */\n.skip-link {\n  position: absolute;\n  left: 12px;\n  top: -60px;\n  z-index: 200;\n  padding: 10px 14px;\n  border-radius: var(--r-1);\n  background: var(--ink);\n  color: #fff;\n  font-weight: 600;\n  font-size: 14px;\n  transition: top 0.15s;\n}\n\n.skip-link:focus {\n  top: 12px;\n  outline: 2px solid var(--brand);\n}\n\n/* ── 레이아웃 ───────────────────────────────────────── */\n.wrap {\n  width: 100%;\n  max-width: var(--wrap);\n  margin: 0 auto;\n  padding: 0 var(--gutter);\n}\n\n.wrap--narrow {\n  max-width: var(--wrap-narrow);\n}\n\n.sec {\n  padding: 88px 0;\n}\n\n.sec--tight {\n  padding: 56px 0;\n}\n\n.sec--alt {\n  background: var(--surface-2);\n  border-top: 1px solid var(--line-2);\n  border-bottom: 1px solid var(--line-2);\n}\n\n.app-main {\n  min-height: calc(100vh - var(--header-h));\n}\n\n/* ── 섹션 헤더 ─────────────────────────────────────── */\n.kicker {\n  font-family: var(--f-m);\n  font-size: var(--t-mono);\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.kicker--brand {\n  color: var(--brand);\n}\n\n.kicker--spark {\n  color: var(--spark-text);\n}\n\n.kicker::before {\n  content: \"\";\n  width: 20px;\n  height: 2px;\n  background: currentColor;\n  opacity: 0.8;\n}\n\n.kicker--plain::before {\n  display: none;\n}\n\n.sec-head {\n  margin-bottom: 40px;\n  max-width: 62ch;\n}\n\n.sec-head--center {\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sec-head--center .kicker {\n  justify-content: center;\n}\n\n.sec-title {\n  font-size: var(--t-h2);\n  font-weight: 800;\n  margin-top: 12px;\n  letter-spacing: -0.028em;\n}\n\n.sec-lede {\n  margin-top: 12px;\n  color: var(--ink-2);\n  font-size: 15.5px;\n  line-height: 1.65;\n  max-width: 58ch;\n}\n\n.sec-head--center .sec-lede {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* ── 페이지 헤더 (내부 페이지) ─────────────────────── */\n.page-head {\n  padding: 44px 0 28px;\n  border-bottom: 1px solid var(--line-2);\n  background:\n    linear-gradient(180deg, var(--surface-2) 0%, var(--surface) 100%);\n}\n\n.page-head .crumb {\n  font-family: var(--f-m);\n  font-size: var(--t-mono);\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.page-head .crumb a:hover {\n  color: var(--brand);\n}\n\n.page-head .crumb .sep {\n  opacity: 0.5;\n}\n\n.page-head h1 {\n  font-size: clamp(28px, 3.4vw, 40px);\n  font-weight: 800;\n  margin-top: 10px;\n  letter-spacing: -0.03em;\n}\n\n.page-head .lede {\n  margin-top: 10px;\n  color: var(--ink-2);\n  max-width: 62ch;\n  font-size: 15px;\n}\n\n.page-head--row {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 24px;\n  flex-wrap: wrap;\n}\n\n.page-body {\n  padding-top: 36px;\n  padding-bottom: 80px;\n}\n\n@media (max-width: 640px) {\n  .page-body {\n    padding-top: 24px;\n    padding-bottom: 56px;\n  }\n  .page-head {\n    padding: 28px 0 22px;\n  }\n}\n\n/* ── 텍스트 유틸 ───────────────────────────────────── */\n.mono {\n  font-family: var(--f-m);\n  font-variant-numeric: tabular-nums;\n}\n\n.num {\n  font-variant-numeric: tabular-nums;\n}\n\n.muted {\n  color: var(--ink-3);\n}\n\n.muted-2 {\n  color: var(--ink-2);\n}\n\n.brand {\n  color: var(--brand);\n}\n\n.spark {\n  color: var(--spark);\n}\n\n.sm {\n  font-size: var(--t-sm);\n}\n\n.xs {\n  font-size: var(--t-xs);\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* ── 플렉스/그리드 유틸 ────────────────────────────── */\n.row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.row--between {\n  justify-content: space-between;\n}\n\n.row--wrap {\n  flex-wrap: wrap;\n}\n\n.col {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.grow {\n  flex: 1;\n  min-width: 0;\n}\n\n.stack > * + * {\n  margin-top: 16px;\n}\n\n/* ── 아이소 격자 배경 ──────────────────────────────── */\n.iso-grid-bg {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.55;\n  background-image:\n    repeating-linear-gradient(26.565deg, transparent 0 33px, var(--iso-grid) 33px 34px),\n    repeating-linear-gradient(-26.565deg, transparent 0 33px, var(--iso-grid) 33px 34px);\n  -webkit-mask-image: radial-gradient(ellipse 66% 62% at 50% 52%, #000 25%, transparent 76%);\n          mask-image: radial-gradient(ellipse 66% 62% at 50% 52%, #000 25%, transparent 76%);\n}\n\n.iso-grid-bg--flat {\n  -webkit-mask-image: linear-gradient(180deg, transparent, #000 20%, #000 80%, transparent);\n          mask-image: linear-gradient(180deg, transparent, #000 20%, #000 80%, transparent);\n}\n\n/* ── 아이소 리프트 (Z축 상승 호버) ─────────────────── */\n.iso-lift {\n  transition: transform var(--dur) var(--ease), box-shadow var(--dur) var(--ease);\n}\n\n.iso-lift:hover {\n  transform: translate(-4px, -4px);\n  box-shadow: var(--sh-iso-hover);\n}\n\n/* ── 등장 애니메이션 ───────────────────────────────── */\n@keyframes rise {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.rise {\n  animation: rise 0.55s var(--ease-out) both;\n}\n\n.rise-1 { animation-delay: 0.05s; }\n.rise-2 { animation-delay: 0.12s; }\n.rise-3 { animation-delay: 0.2s; }\n.rise-4 { animation-delay: 0.28s; }\n.rise-5 { animation-delay: 0.36s; }\n\n@keyframes fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html {\n    scroll-behavior: auto;\n  }\n  *, *::before, *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n  }\n}\n\n/* ── 스크롤바 (웹킷) ────────────────────────────────── */\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--line-strong);\n  border-radius: 10px;\n  border: 2px solid var(--surface);\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
